import Image from 'next/image';
import { AnchorArrow } from 'react-scale/components';
import { customersLogos } from './logos';

import styles from './logo-grid.module.css';

const cx = require('classnames');

// eslint-disable-next-line no-return-assign
const LogoFarm = ({ theme, text, logos, limit, columns, flex }) => (
  <div className="relative grid text-white">
    <ul
      className={cx(
        'items-center justify-center gap-8 gap-y-10 md:gap-y-16',
        { grid: !flex },
        { 'grid justify-between lg:flex': flex },
        `lg:grid-cols-${columns.lg}`,
        `md:grid-cols-${columns.md}`,
        `sm:grid-cols-${columns.sm}`,
        `grid-cols-${columns.xs}`
      )}
    >
      {logos.slice(0, limit).map((logo, index) => (
        <CustomerLogo
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          logo={logo.src ? logo : customersLogos[typeof logo === 'string' ? logo : logo.name]}
          theme={theme}
        />
      ))}
    </ul>

    {text && (
      <p className="mt-16 text-base text-center text-silver">
        <span className="mr-2">Trusted by the world’s most ambitious AI teams.</span>
        <span className="inline">
          <AnchorArrow href="/customers" text="Meet our customers" />
        </span>
      </p>
    )}
  </div>
);

const CustomerLogo = ({ logo, theme }) => (
  <li key={logo.alt} className="flex justify-center align-middle ">
    <Image
      layout="intrinsic"
      width={logo.width}
      height={logo.height}
      className={`${styles.logoImg} ${icon[theme]}`}
      src={logo.src}
      alt={logo.alt}
      quality={100}
    />
  </li>
);

const icon = {
  dark: styles.dark,
  light: styles.light
};

LogoFarm.defaultProps = {
  theme: 'dark',
  columns: { xs: 4, sm: 4, md: 7, lg: 7 },
  limit: 32,
  text: false,
  flex: false,
  logos: [
    'microsoft',
    'faire',
    'brex',
    'etsy',
    'gm',
    'flexport',
    'instacart',
    'blend',
    'openai',
    'paypal',
    'sap',
    'square',
    'toyota',
    'airforce',
    'usarmy',
    'irobot',
    'lyft',
    'linkedin',
    'nuro',
    'pinterest',
    'skydio'
  ]
};

export default LogoFarm;
